module.exports = __webpack_public_path__ + "logo.svg?5abda1784b48fd4cbcd0ac232a9e5048";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 79
// module chunks = 0